import { motion } from "framer-motion";
import { Cpu, Zap, Sparkles, Wallet, BadgeCheck, FileCheck } from "lucide-react";

const features = [
  { icon: Cpu, t: "Smart Pricing Engine", d: "Models trained on India's largest premium motorcycle dataset." },
  { icon: Zap, t: "Instant Valuation", d: "Real-time pricing the moment you submit your details." },
  { icon: Sparkles, t: "India's Biggest Premium Bike Reseller", d: "We deal in bikes from 150cc to 1000cc and beyond." },
  { icon: Wallet, t: "Fast Payouts", d: "Bank-grade transfers, within the same day." },
  { icon: BadgeCheck, t: "Peace of Mind", d: "Every motorcycle goes through an extreme vehicle inspection — buyers get their ride as good as new." },
  { icon: FileCheck, t: "Warranty & Paperwork Handled", d: "Buyers get a limited-period warranty and we handle all the paperwork for a hassle-free experience." },
];

export default function Features() {
  return (
    <section data-testid="features-section" className="relative py-24 md:py-36 bg-[#0D0F12]">
      <div className="absolute inset-0 grid-bg opacity-10" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#00cccc]">// Why Biker Boulevard</span>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            Built different. <br />
            <span className="text-gradient-cyan">Engineered for riders.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <motion.div
              key={f.t}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              whileHover={{ y: -4 }}
              className="group relative p-6 rounded-2xl glass hover:border-[#00cccc]/50 transition-all duration-300 overflow-hidden"
              data-testid={`feature-card-${i + 1}`}
            >
              <div className="absolute -inset-px rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{ background: "radial-gradient(circle at top, rgba(0,204,204,0.15), transparent 60%)" }} />
              <div className="relative">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-[#00cccc]/10 border border-[#00cccc]/20 group-hover:border-[#00cccc]/60 group-hover:bg-[#00cccc]/20 transition-all duration-300">
                  <f.icon className="w-5 h-5 text-[#00cccc]" />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-white">{f.t}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{f.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
